@if (routes && (routes | shouldShowConfirmedRouting)) {
  <div class="routing-confirmed">
    <div class="routing-confirmed__label">{{ 'ROUTING (CONFIRMED)' }}</div>
    <ul class="sgl-timeline">
      @for (route of routes; track index; let index = $index; let last = $last) {
        <li class="sgl-timeline__item">
          @if (route.origin) {
            <span class="routing-confirmed__label">{{ route.origin | formatRouteLocation }}</span>
          }
          @if (route.closingShipment) {
            <div class="routing-confirmed__date">
              {{ 'CLOSING SHIPMENT: ' }}{{ route.closingShipment | date }}
              @if (route.closingShipment | isNotMidnight) {
                {{ ' ' }}{{ route.closingShipment | date: timeFormat }}
              }
            </div>
          }

          @if (index > 0 && routes[index - 1].etaLocal && route.transportSegment !== 'Pickup') {
            <span class="routing-confirmed__date">
              {{ 'ETA: ' }} {{ routes[index - 1].etaLocal | date }}
              @if (routes[index - 1].etaLocal | isNotMidnight) {
                {{ ' ' }}{{ routes[index - 1].etaLocal | date: timeFormat }}
              }
            </span>
          }

          @if (route.etdLocal) {
            <span class="routing-confirmed__date"
              >{{ 'ETD: ' }}{{ route.etdLocal | date }}
              @if (route.etdLocal | isNotMidnight) {
                {{ ' ' }}{{ route.etdLocal | date: timeFormat }}
              }
            </span>
          }
        </li>

        @if (route.destination && last) {
          <li class="sgl-timeline__item routing-confirmed">
            <span class="routing-confirmed__label">{{ route.destination | formatRouteLocation }}</span>
            @if (route.etaLocal) {
              <span class="routing-confirmed__date"
                >{{ 'ETA: ' }}{{ route.etaLocal | date }}
                @if (route.etaLocal | isNotMidnight) {
                  {{ ' ' }}{{ route.etaLocal | date: timeFormat }}
                }
              </span>
            }
          </li>
        }
      }
    </ul>
  </div>
}
